(function () {
  'use strict';

  let isEnforcing = false;
  let pendingCheck = false;
  let ownDispatch = false;

  function isRestrictedItem(item) {
    return (
      item.product_type === 'Shipping Protection' ||
      !!(item.properties && item.properties.udrp_gift)
    );
  }

  async function enforceQuantityLimits() {
    if (isEnforcing) {
      pendingCheck = true;
      return;
    }

    isEnforcing = true;
    pendingCheck = false;

    try {
      const cartResp = await fetch('/cart.js');
      if (!cartResp.ok) return;

      const cart = await cartResp.json();

      // Group restricted items by product_id, preserving cart order (earliest first)
      const groups = new Map();
      for (const item of cart.items) {
        if (!isRestrictedItem(item)) continue;
        if (!groups.has(item.product_id)) {
          groups.set(item.product_id, []);
        }
        groups.get(item.product_id).push(item);
      }

      let madeChanges = false;

      for (const groupItems of groups.values()) {
        const totalQty = groupItems.reduce((sum, item) => sum + item.quantity, 0);
        if (totalQty <= 1) continue;

        // Trim from front (earliest-added lines) until combined total reaches 1
        let remaining = totalQty;
        for (const item of groupItems) {
          if (remaining <= 1) break;

          const excess = remaining - 1;
          const removeFromItem = Math.min(item.quantity, excess);
          const newQty = item.quantity - removeFromItem;

          // item.key uniquely identifies the line item even across identical variants
          const changeResp = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: newQty }),
          });

          if (changeResp.ok) {
            remaining -= removeFromItem;
            madeChanges = true;
          }
        }
      }

      if (madeChanges) {
        ownDispatch = true;
        window.dispatchEvent(new CustomEvent('cart:change'));
        ownDispatch = false;
      }
    } catch (_) {
      // Silent enforcement — surface no errors to the user
    } finally {
      isEnforcing = false;
      if (pendingCheck) {
        pendingCheck = false;
        setTimeout(enforceQuantityLimits, 0);
      }
    }
  }

  function handleCartMutation() {
    if (isEnforcing) {
      pendingCheck = true;
      return;
    }
    enforceQuantityLimits();
  }

  // CartJS library dispatches these on document after its fetch calls succeed
  document.addEventListener('cart.added', handleCartMutation);
  document.addEventListener('cart.changed', handleCartMutation);
  document.addEventListener('cart.updated', handleCartMutation);

  // add-product-form dispatches cart:change as a composed event that bubbles to window
  window.addEventListener('cart:change', function () {
    if (ownDispatch) return;
    handleCartMutation();
  });
})();
